import { Button } from "design-system/atoms/Button"
import { Plus } from "lucide-react"
import { useGetBackofficeOrganizationCreditsQuery } from "modules/backoffice/hooks/organizations/useGetBackofficeOrganizationCreditsQuery"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Route as CreditsListRoute } from "routes/_base/_auth/backoffice/organizations/$id/credits/list"
import { BackofficeAddCreditsModal } from "./BackofficeAddCreditsModal"
import { BackofficeCreditsTable } from "./BackofficeCreditsTable"

export const BackofficeOrganizationCredits = () => {
  const { t } = useTranslation()
  const { id } = CreditsListRoute.useParams()
  const [isAddCreditsOpen, setIsAddCreditsOpen] = useState(false)

  const { data, isPending } = useGetBackofficeOrganizationCreditsQuery({ id })

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex justify-end">
          <Button variant="default" onClick={() => setIsAddCreditsOpen(true)}>
            <Plus />
            {t("backoffice.credits.add")}
          </Button>
        </div>
        <BackofficeCreditsTable credits={data} isPending={isPending} />
      </div>
      {isAddCreditsOpen && (
        <BackofficeAddCreditsModal onOpenChange={() => setIsAddCreditsOpen(false)} />
      )}
    </>
  )
}
